import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {SortingState,IntegratedSorting,PagingState,IntegratedPaging,SearchState,IntegratedFiltering} from '@devexpress/dx-react-grid';
import {Grid,Table,TableHeaderRow,SearchPanel,Toolbar,TableColumnVisibility,ColumnChooser} from '@devexpress/dx-react-grid-bootstrap4';
import { PagingPanel} from '@devexpress/dx-react-grid-material-ui';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
var styles=require('./Report.less');
import {DropdownButton, MenuItem, Button} from 'react-bootstrap';
import * as reportActions from './../../actions/reportActions';
 import moment from 'moment';
import '../../theme/styles/styles.css';
import momenttz from 'moment-timezone';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as commonActions from './../../actions/commonActions';
import config from './../../config.js';
import {DcoDropdown} from './../../components/UI/Dropdown/Dropdown';
import '../../theme/styles/mediaqueries.css';
import Modal from 'react-modal';
import * as filesaver from './../../actions/FileSaver';
import i18next from 'i18next';
import { applyStyle,applyToHover } from './../../utils/utils';
import { withStyles } from '@material-ui/core/styles';
import DateSelector from './../DateSelector/DateSelector';
import {getSelectedDate,getCountofTableRows,setDirection} from './../../utils/utils'; //import
import numeral  from 'numeral';
import {getPath} from './../../actions/commonActions';
const elementsData = [
  {"classNames":"alldealfilterBar", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"alldealtbl", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"fltrBarInner", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"reportsDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-toggle", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"dropDownList","elementType":"tag", "applyTo":"all", "tagNames":"a"},
  {"classNames":"reportTblBg", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"glyphicon","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"material-icons","elementType":"normal", "applyTo":"all", "tagNames":"i"},
  {"classNames":"reportsTblGrid","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"form-control","elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"oi-eye","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"dx-g-bs4-table","elementType":"normal", "applyTo":"all", "tagNames":"table"},
  {"classNames":"dx-g-bs4-header-cell","elementType":"tag", "applyTo":"all", "tagNames":"th"},
  {"classNames":"dx-g-bs4-table-cell","elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"noDataCell","elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"text-muted","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"closeBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"}
];
const directionData=[
  {"classNames":"alldealfilterItemdrop", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"selectDatebtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"alldealdrpdown", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"allExportFilter", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"commonGoBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"btnText","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"reportsTblGrid","elementType":"normal", "applyTo":"all", "tagNames":"div"},
];
import ReactExport from "react-data-export";
let compareRate = (a, b) => {
  let result;
    if (numeral(a)._value < numeral(b)._value) {
      result = -1;
    }else{
      result = 1;
    }
    return result;
};
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

@connect(state => ({
    alldealtbleData: state.dashboardRoot.reportReducer.alldealtbleData,
    defAcc: state.dashboardRoot.dashboardReducer.defAcc,
    ACD: state.auth.ACD,
    DFA: state.auth.DFA,
    DCO:state.dashboardRoot.instrumentListReducer.DCO,
    userDetail: state.auth.userDetail,
    selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
    socketDataStatic: state.dashboardRoot.instrumentListReducer.socketDataStatic,
    openCalender: state.dashboardRoot.commonReducer.openCalender,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    language:state.dashboardRoot.commonReducer.language,
    stockCodeList:state.dashboardRoot.dashboardReducer.stockCodeList,
    yearList: state.auth.userDetail.yearList
}), {
  ...reportActions,
  ...instrumentListActions,
  ...commonActions
})

export default class ReportComponent extends Component {
  static propTypes = {
    getExportedReport: PropTypes.func,
    alldealtbleData: PropTypes.object,
    loadAlldealReport: PropTypes.func,
    getInvoice: PropTypes.func,
    ACD: PropTypes.object,
    DFA: PropTypes.object,
    socketDataStatic: PropTypes.array,
    openCalender:PropTypes.boolean,
    onClickCalender:PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.state = {
      account_name: this.props.DFA.D,
      account_code:this.props.DFA.C,
      cmdtyDesc: '',
      alldealTrd_opt: 'allTrades',
      createdByValue: 'createdByAll',
      createdByKey:"2",
      cmdtyKey:'',
      cmdtyKeyCol:'',
      alldealTrd_optKey:'ALL',
      CmdtyPairdata: [],
      qty_type:'',
      showRptDialog: false,
      currentDate: new Date().toLocaleDateString('en-US'),
      startDate: new Date().toLocaleDateString('en-US'),
      endDate: new Date().toLocaleDateString('en-US'),
      loadtableflag: true,
      isClearAllDeal: false,
      isRefreshDisabled:  true,
      ranges: {
        [i18next.t('today')]: [
          moment(), moment()
        ],
        [i18next.t('yesterday')]: [
          moment().subtract(1, 'days'),
          moment().subtract(1, 'days')
        ],
        [i18next.t('last7Days')]: [
          moment().subtract(6, 'days'),
          moment()
        ],
        [i18next.t('last30Days')]: [
          moment().subtract(29, 'days'),
          moment()
        ],
        [i18next.t('thisMonth')]: [
          moment().startOf('month'), moment().endOf('month')
        ],
        [i18next.t('lastMonth')]: [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month')
        ]
      },
     alldealtbleData:this.props.alldealtbleData,
     allDealColumnOrder:['user_code','docno','docdate','valdate','deal_type','inst_desc','grs_qty','mtl_rate','amt','evt_ts','remarks'],
     HiddenAllDealCol:[],
     pageSizes: [10, 15, 20, 0],
     searchValue:'',
     accountList:Array.from(this.props.ACD.values()),
     integratedSortingColumnExtensions: [
         { columnName: 'grs_qty', compare: compareRate, align:'right' },
         { columnName: 'mtl_rate', compare: compareRate, align:'right' },
         { columnName: 'amt', compare: compareRate, align:'right' },
       ],
      COM:null,
      qtyTypeColName:'',
      validationFlag:false,
      id:'today',
      keyValue:'alldealReport',
      reportsRowsCount:0,
      stkCodeList:[],
      yearListHeading:""
    }
    this.onChangeSearchValue = this.onChangeSearchValue.bind(this);
    this.onChangeHiddenAllDealCol = this.onChangeHiddenAllDealCol.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    // //const allCssStyleRules = this.props.selectedCssColorTheme;
    // applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
    ];
   // //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
     let obj1 = {
       cmdtId: 'All',
       cmdtDesc: i18next.t('allPairs')
     };
     var dcoObj=this.props.DCO;
     if(dcoObj.findIndex(x => x.cmdtId=="All") === -1 && dcoObj.length > 1){
       dcoObj.unshift(obj1);
     }
     this.setState({account_name: this.props.DFA.D,
                    account_code:this.props.DFA.C,
                    COM:null,
                    CmdtyPairdata: dcoObj,
                    qtyTypeColName:this.props.stockCodeList[0].unit_code,
                    cmdtyKey :dcoObj[0].cmdtId,cmdtyDesc:dcoObj[0].cmdtDesc,cmdtyKeyCol:dcoObj[0].cmdtId,
                    stkCodeList:this.props.stockCodeList,qty_type:this.props.stockCodeList[0].unit_code,
                    yearListHeading:this.props.yearList[0].YEAR},()=>{this.onClickFilter()});
  }

  componentWillMount() {
    const locale = locale;
    this.setState({
        locale: {
            'format': 'DD-MM-YYYY',
            applyLabel: i18next.t('apply'),
            cancelLabel: i18next.t('cancel'),
            customRangeLabel:  i18next.t('customRange'),
            daysOfWeek: [
              i18next.t("su"),i18next.t("mo"),i18next.t("tu"),i18next.t("we"),i18next.t("th"),i18next.t("fr"),i18next.t("sa")
            ],
            monthNames:[
              i18next.t("jan"),i18next.t("feb"),i18next.t("mar"),i18next.t("apr"),i18next.t("may"),i18next.t("jun"),i18next.t("jul"),  i18next.t("aug"),i18next.t("sep"),i18next.t("oct"),i18next.t("nov"),i18next.t("dec")
            ]
        },
        });
  }

  closeRptModal = (event) => {
    try{
      this.setState({showRptDialog: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeRptModal', component:"AlldealReport"});
    }
  }

  handleEvent = (event,picker) => {
    try{
      this.setState({startDate: picker.startDate.format('DD-MM-YYYY'), endDate: picker.endDate.format('DD-MM-YYYY')});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleEvent', component:"AlldealReport"});
    }
  }

  getAllDealRegData = (startDate, endDate, cmdtyKey, alldealTrd_optKey, createdByKey, account_code, qtyType) => {
    try {
      this.setState({
        loadtableflag: true,
        isRefreshDisabled: true,
        qtyTypeColName: qtyType,
        cmdtyKeyCol: cmdtyKey
      }, () => { this.onClickFilter() });
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'getAllDealRegData', component: "AlldealReport" });
    }
  }

  componentWillReceiveProps(nextProps){
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   const hoverElementsClassNames = [
    //       {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
    //       {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    // };
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
      let obj1 = {
        cmdtId: 'All',
        cmdtDesc: i18next.t('allPairs')
      };
      var obj=this.props.DCO;
      if(obj.findIndex(x => x.cmdtId=='All') === -1 && obj.length > 1){
        obj.unshift(obj1);
      }else{
        var index = obj.findIndex(x => x.cmdtId=='All' );
        obj.splice(index,1);
        obj.unshift(obj1);
      }
      this.setState({CmdtyPairdata: obj,
                     cmdtyKey: obj[0].cmdtId,
                     cmdtyDesc: obj[0].cmdtDesc});
    }
    if(this.state.isClearAllDeal !== this.props.isClearAllDeal){
      this.setState({ isClearAllDeal: true ,
                      loadtableflag: true ,
                      isRefreshDisabled : true ,
                      account_name: this.props.DFA.D ,
                      account_code: this.props.DFA.C ,
                      cmdtyDesc: this.props.DCO[0].cmdtDesc,
                      cmdtyKey:this.props.DCO[0].cmdtId,
                      cmdtyKeyCol:this.props.DCO[0].cmdtId,
                      alldealTrd_opt: 'allTrades' ,
                      alldealTrd_optKey: 'ALL' ,
                      createdByValue:'createdByAll',
                      startDate: new Date().toLocaleDateString('en-US'),
                      endDate:new Date().toLocaleDateString('en-US'),
                      currentDate: new Date().toLocaleDateString('en-US'),
                      id:'today'});
    }
    if(nextProps.alldealtbleData !== this.props.alldealtbleData){
      this.setState({ loadtableflag: false,
                      isRefreshDisabled : false,
                      reportsRowsCount : nextProps.alldealtbleData.length });
    }
    if(nextProps.defAcc !== this.props.defAcc){
      this.setState({account_name: nextProps.defAcc.AD, account_code:nextProps.defAcc.AC});
    }
  }

  onStartDateChange = startDate => {
    try{
      this.setState({ startDate:startDate});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onStartDateChange', component:"AlldealReport"});
    }
  }

  onEndDateChange = endDate => {
    try{
       this.setState({ endDate:endDate });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onEndDateChange', component:"AlldealReport"});
    }
  }

  closeValidationModal=()=>{
    try{
      this.setState({validationFlag :false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeValidationModal', component:"AlldealReport"});
    }
  }

  onChangeAccount = (text, key) => {
    try {
      this.setState({
        account_name: text,
        account_code: key,
        loadtableflag: true
      }, () => { this.onClickFilter() });
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'onChangeAccount', component: "AlldealReport" });
    }
  }

   onClickFilter = () => {
    this.setState({ loadtableflag : true });
    this.props.loadAlldealReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),this.state.cmdtyKey,this.state.alldealTrd_optKey,this.state.createdByKey,this.state.account_code,this.state.qty_type,this.state.yearListHeading);
   }

   onChnageCmdty = (cmdtyid, desc) => {
    try {
      if (cmdtyid == 'All') {
        this.setState({ COM: null });
      } else {
        let index1;
        for (let index = 0; index < this.props.socketDataStatic.length; index++) {
          const cmdty = this.props.socketDataStatic[index].I;
          const cmdtyDes = this.props.socketDataStatic[index].ID;
          if (cmdtyid === cmdty) {
            index1 = index;
          }
        }
        this.setState({ COM: parseInt((this.props.socketDataStatic[index1]).B) });
      }
      this.setState({
        cmdtyDesc: desc,
        cmdtyKey: cmdtyid,
        loadtableflag: true
      }, () => { this.onClickFilter() });
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'onChnageCmdty', component: "AlldealReport" });
    }
   }

  onChangeTrd_opt = (text, key) => {
      try {
        this.setState({ alldealTrd_opt: text, alldealTrd_optKey: key, loadtableflag: true }, () => { this.onClickFilter() });
      } catch (e) {
        this.props.logFileCreation({ error: e.message, originFunction: 'onChangeTrd_opt', component: "AlldealReport" });
      }
   }

  onChangeTrdCreatedBy = (text, key) => {
      try {
        this.setState({
          createdByValue: text,
          createdByKey: key,
          loadtableflag: true
        }, () => { this.onClickFilter() });
      } catch (e) {
        this.props.logFileCreation({ error: e.message, originFunction: 'onChangeTrdCreatedBy', component: "AlldealReport" });
      }
   }

  changeFlag = () => {
    try{
    	this.setState({showRptDialog: true});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeFlag', component:"AlldealReport"});
    }
  }

  generatePdf=(format)=>{
    try{
      const startDate=moment(this.state.startDate).format('DD-MM-YYYY');
      const endDate=moment(this.state.endDate).format('DD-MM-YYYY');
      const cmdtyKey=this.state.cmdtyKey;
      const alldealTrd_optKey=this.state.alldealTrd_optKey;
      const createdByKey=this.state.createdByKey;
      const account_code=this.state.account_code;
      const qty_type=this.state.qty_type;
      const yearListHeading=this.state.yearListHeading;
      const user = JSON.parse(localStorage.getItem('user'));
      const platform = localStorage.getItem('platform');
      const region = navigator.language;
      let response = '';
      if (this.props.alldealtbleData.length === 0 || this.props.alldealtbleData === '' || this.props.alldealtbleData === null) {
        this.setState({ showRptDialog: true });
      } else if (format === 'PDF') {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', getPath("api") + '/user/generateDealRegPDF?startDate='+startDate+'&endDate='+endDate+'&cmdty='+cmdtyKey+'&docType='+alldealTrd_optKey+'&createdBy='+createdByKey+'&stkCode='+qty_type+'&Year='+yearListHeading+'&timezone='+Intl.DateTimeFormat().resolvedOptions().timeZone+'&region='+region);
        xhr.setRequestHeader('SID', this.props.userDetail.SID);
        xhr.setRequestHeader('username', this.props.userDetail.UID);
        xhr.setRequestHeader('location', user.location);
        xhr.setRequestHeader('Cache-Control','no-cache');
        xhr.setRequestHeader('accCode',account_code);
        xhr.setRequestHeader('platform',platform);
        xhr.responseType = 'blob';
        xhr.onload = function (dispatch) {
        if(xhr.status === 200){
          filesaver.saveAs(xhr.response, "All_Deal_Report_" + startDate + "_to_" + endDate + ".pdf");
        } else{
          this.changeFlag();
        }
      }.bind(this);
        xhr.send();
      } else {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', config.apiPath + '/user/export_AllDealReg_xls?startDate='+startDate+'&endDate='+endDate+'&cmdty='+cmdtyKey+'&docType='+alldealTrd_optKey+'&createdBy='+createdByKey+'&stkCode='+qty_type);
          xhr.setRequestHeader('SID', this.props.userDetail.SID);
          xhr.setRequestHeader('username', this.props.userDetail.UID);
          xhr.setRequestHeader('location', user.location);
          xhr.setRequestHeader('Cache-Control','no-cache');
          xhr.setRequestHeader('accCode',account_code);
          xhr.setRequestHeader('platform',platform);
          xhr.responseType = 'blob';
          xhr.onload = function (e) {
            if(xhr.status === 200){
                filesaver.saveAs(xhr.response, "All_Deal_Report_" + startDate + "_to_" + endDate +".xlsx");
            }else{
              this.changeFlag();
            }
          }.bind(this);
          xhr.send();
        };
      //this.props.getExportedReport(startDate,endDate,cmdtyKey,alldealTrd_optKey,createdByKey,account_code,alldealQty_opt,format);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'generatePdf', component:"AlldealReport"});
    }
  }

   generateInvoice=(row)=>{
     try {
       var docNo = row.toString().split('""');
       var getdocType = row.toString().split('/');
       var docType = getdocType[0];
       if (docType !== 'PFC') {
         this.props.getInvoice(docNo, docType, this.state.yearListHeading);
       }
     } catch (e) {
       this.props.logFileCreation({ error: e.message, originFunction: 'generateInvoice', component: "AlldealReport" });
     }
   }

  onChangeSearchValue(value){
    try{
      var count=getCountofTableRows(this.props.alldealtbleData,this.state.allDealColumnOrder,value);
      this.setState({searchValue: value, reportsRowsCount: count });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeSearchValue', component:"AlldealReport"});
    }
  }

  onChangeHiddenAllDealCol(hiddenCol){
    try{
     this.setState({ HiddenAllDealCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenAllDealCol', component:"AlldealReport"});
    }
  };

  onChnageQtyType = (stk_code) => {
    try {
      this.setState({
        qty_type: stk_code,
        qtyTypeColName: stk_code,
        loadtableflag: true
      }, () => { this.onClickFilter() });
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'onChnageQtyType', component: "AlldealReport" });
    }
  }

  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      ////const allCssStyleRules = this.props.selectedCssColorTheme;
      const elementsData = [
        {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"button"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      // applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
      ];
      ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"AlldealReport"});
    }
  }

  setStartDate = startDate => {
    try{
      this.setState({ startDate});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setStartDate', component:"AlldealReport"});
    }
  }

  setEndDate = endDate => {
    try{
      this.setState({ endDate });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setEndDate', component:"AlldealReport"});
    }
  }

  setYearHeading = (yearListHeading) => {
    try{
      this.setState({ yearListHeading });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setYearHeading', component:"AlldealReport"});
    }
  };

  render() {
    const integratedSortingColumnExtensions= this.props.language !='AR'?
      [
        { columnName: 'grs_qty', compare: compareRate, align:'right' },
        { columnName: 'mtl_rate', compare: compareRate, align:'right' },
        { columnName: 'amt', compare: compareRate, align:'right' },
      ]:
      [
        { columnName: 'grs_qty', compare: compareRate, align:'left' },
        { columnName: 'mtl_rate', compare: compareRate, align:'left' },
        { columnName: 'amt', compare: compareRate, align:'left' },
      ];
    const {account_name,cmdtyDesc,alldealTrd_opt,createdByValue,cmdtyKey,CmdtyPairdata,startDate,endDate,alldealTrd_optKey,createdByKey,account_code,COM}=this.state;
    let label = this.state.startDate+ ' - ' +this.state.endDate;
    if (this.state.startDate === this.state.endDate) {
      label = this.state.endDate;
    }
    var cmdtyLable='';
	  if(COM === 1){
         cmdtyLable  = i18next.t('quantity');
     }else {
        cmdtyLable  = i18next.t('quantity') +" "+ "("+this.state.qtyTypeColName+")";
    }

    const alldealcols= [
     {name: 'user_code',title: i18next.t('user'), width: {wpx: 90} },
     {name: 'docno',title: i18next.t('docNo'), width: {wpx: 150} },
     {name: 'docdate',title: i18next.t('docDate'), width: {wpx: 100} },
     {name: 'valdate',title: i18next.t('valueDate'), width: {wpx: 100} },
     {name: 'deal_type',title: i18next.t('deal'), width: {wpx: 60} },
     {name: 'inst_desc',title: i18next.t('cmdtyPair'), width: {wpx: 90} },
     {name: 'grs_qty',title: cmdtyLable, width: {wpx: 110}},
     {name: 'mtl_rate',title: i18next.t('price'), width: {wpx: 110} },
     {name: 'amt',title: i18next.t('amount'), width: {wpx: 110} },
     {name: 'evt_ts',title: i18next.t('eventTime'), width: {wpx: 200} },
     {name: 'remarks',title: i18next.t('comments'), width: {wpx: 400} }
    ];

    var tableData = [];
    var propData = this.props.alldealtbleData;

   for(let i=0;i<propData.length;i++){
      tableData[i] = [{value: propData[i].user_code, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].docdate, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].valdate, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].inst_desc, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].grs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].mtl_rate, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].amt, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].evt_ts, style: {alignment: {horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}];
    }

   let multiDataSet = [
     {
       columns: alldealcols,
       data: tableData
     }
   ];
   const pagingPanelMessages = {
     showAll: i18next.t('all'),
     rowsPerPage: i18next.t('rowsPerPage'),
     info:'',
   };
   const searchPlaceholderMsg = {
     searchPlaceholder: (i18next.t('search'))+'...',
   };
    const PagingContainer = props => (
      <PagingPanel.Container {...props} className="pagingPanelDiv" />
    );
    const PagingContainerdark = props => (
      <PagingPanel.Container {...props} className="pagingPanelDivDark"  />
    );

    const GenerateInvoiceCell = ({ value, style }) => (
      <Table.Cell>
        <span>
        { value.indexOf('PFC') === -1 ? <a className='trdeBookCell' title={i18next.t("invoiceDownldMsg")} onClick={()=>this.generateInvoice(value)}>
            {value}
          </a>
        :value}
        </span>
      </Table.Cell>
    );

    const TableCell = props => {
      const { column } = props;
      if (column.name === "docno") {
        return <GenerateInvoiceCell {...props} />;
      }
      if(column.name === "grs_qty" || column.name === "mtl_rate" || column.name === "amt"){
          return <Table.Cell {...props} className="textAlignLeft"/>;
      }
      if(column.name === "evt_ts"){
          return <Table.Cell {...props} className="eventTimeCell"/>;
      }
      if(column.name === "docdate" || column.name === "valdate"){
          return <Table.Cell {...props} className="commonDateAR"/>;
      }
        return <Table.Cell {...props} />;
    };

    const rowStyle = theme => ({
      tableStriped: {
        '& tbody tr:nth-of-type(odd)': {
          //backgroundColor: this.props.selectedCssColorTheme.listRow.background,
          //color:this.props.selectedCssColorTheme.listRow.color
        },
        '& tbody tr:nth-of-type(even)': {
          // backgroundColor: this.props.selectedCssColorTheme.rptListRowNext.background,
          // color:this.props.selectedCssColorTheme.listRow.color
        },
        '& thead th': {
          ////color:this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        '& .text-primary': {
          ////color: this.props.selectedCssColorTheme.activeHeaderColor.color
        }
      },
    });

    const TableComponentBase = ({ classes, ...restProps }) => (
      <Table.Table {...restProps} id="allDealRptTable" className={classes.tableStriped}/>
    );

    var NoDataMsg = {
        noData: '',
      }
    if (this.state.loadtableflag === true) {
      NoDataMsg.noData = '';
    }
    else {
      NoDataMsg.noData = i18next.t('noDataAvlMsg');
    }
    const NoDataCell = props => (
      <Table.NoDataCell {...props} className="noDataCell" />
    );

    const dropDownListColor =theme =>({
      dropDownListHoverMenu:{
        '& .dropdown-item':{
            // background:this.props.selectedCssColorTheme.dropDownList.background,
            // color:this.props.selectedCssColorTheme.dropDownList.color
          },
          '& :hover':{
            // background:this.props.selectedCssColorTheme.dropDownListHover.background,
            // color:this.props.selectedCssColorTheme.dropDownListHover.color
          },
          '& .popover':{
            //background:this.props.selectedCssColorTheme.dropDownListHover.background
          }
      }
    });

    const ContainerColor = ({ classes, ...restProps }) => (
      <ColumnChooser.Container {...restProps} className={classes.dropDownListHoverMenu}  />
    );
    const MenuColor = props => (
      <ColumnChooser.Item {...props} />
    );

    return (
      <div id="allDealRptDiv" className={`${this.props.selectedCssColor} ${this.props.language}`}>
        <Modal isOpen={this.state.validationFlag} id="allDealDateValModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
          <div  ref="errorMSG" className="mdlWrap" >
            <div className={`${styles.header} header`} >{i18next.t("error")}
              <span onClick={this.closeValidationModal} className={`${styles.closeImg} closeIcon`}>{this.props.closeIcon}</span>
            </div>
            <div className={`${styles.msg} commonMsgDir`} >
              <h4>{i18next.t("dateSelectorErrMsg")}</h4>
            </div>
          </div>
        </Modal>
          <Modal isOpen={this.state.showRptDialog} className={styles.warningModal} id="idlRptModal" onAfterOpen={this.afterOpenModal}>
              <div  ref="errorMSG" className="mdlWrap" >
                  <div className={`${styles.header} header`} >
                      <span className={`${styles.msgTitle}`}>{i18next.t("allDealsReg")}</span>
                      <span onClick={this.closeRptModal} className={`${styles.closeImg} closeIcon`} id="idlRptCloseIcon">{this.props.closeIcon}</span>
                  </div>
                  <div className={`${styles.msg} commonMsgDir`} >
                      {i18next.t("noDataAvlMsg")}
                  </div>
                  <div className={`${styles.btnWrap} col-md-12`}>
                      <Button className='button-l' bsStyle="primary" onClick={this.closeRptModal} id="idlRptCloseBtn" >{i18next.t("OK")}</Button>
                  </div>
              </div>
          </Modal>
          <div className={`${styles.alldealfilterBar} ${this.props.selectedCssColor} alldealrptBar alldealfilterBar`}>
              <div className={`${styles.alldealfilterBarInner} fltrBarInner`}>
                  <div className={styles.optionsWrapper}>
                      <div
                          className={`${styles.wrapper1} alldealfilterItemdrop`}
                          id="alldealaccdropdown"
                      >
                          <DropdownButton
                          title={i18next.t(account_name)}
                          id="bg-nested-dropdown"
                          className={`${styles.alldealAccount} reportsDropdown btnText`}
                          >
                          {this.state.accountList.map((item) => {
                              return (
                              <MenuItem
                                  onClick={() => this.onChangeAccount(item.D, item.C)}
                                  id="idlRptAccMenu"
                              >
                                  {item.D}
                              </MenuItem>
                              );
                          })}
                          </DropdownButton>
                      </div>
                      <div
                          className={`${styles.selectDatebtn} selectDatebtn`}
                          id="allDealSelectDateDropdown"
                      >
                          <DateSelector
                          keyValue={this.state.keyValue}
                          onClickFilter={this.onClickFilter}
                          setStartDate={this.setStartDate}
                          setYearHeading={this.setYearHeading}
                          setEndDate={this.setEndDate}
                          component="Report"
                          />
                      </div>
                      <DcoDropdown
                          parentDivClassname={`${styles.alldealfilterItem} alldealdrpdown`}
                          parentDivId="ScrollCss"
                          dropdownTitle={i18next.t(cmdtyDesc)}
                          dropdownId="bg-nested-dropdown"
                          dropdownData={this.state.CmdtyPairdata}
                          dataItemClick={this.onChnageCmdty}
                          dropdownClassname="reportsDropdown btnText"
                      />
                      <div
                          className={`${styles.alldealfiltertrdType} alldealdrpdown`}
                          id="allDealQtyType"
                      >
                          <DropdownButton
                          title={i18next.t(this.state.qty_type)}
                          id="dropdown-size-medium"
                          className="reportsDropdown btnText"
                          disabled={COM === 1}
                          >
                          {this.state.stkCodeList.map((item) => {
                              return (
                              <MenuItem
                                  onClick={() => this.onChnageQtyType(item.unit_code)}
                                  id="qtyType"
                              >
                                  {item.unit_code}
                              </MenuItem>
                              );
                          })}
                          </DropdownButton>
                      </div>
                      <div
                          className={`${styles.alldealfiltertrdType} alldealdrpdown`}
                          id="allDealFilterType"
                      >
                          <DropdownButton
                          title={i18next.t(alldealTrd_opt)}
                          id="bg-nested-dropdown"
                          className="reportsDropdown btnText"
                          >
                          <MenuItem
                              onClick={() => this.onChangeTrd_opt("allTrades", "ALL")}
                              id="idlRptAllTrades"
                          >
                              {i18next.t("allTrades")}
                          </MenuItem>
                          <MenuItem
                              onClick={() => this.onChangeTrd_opt("platform", "PH")}
                              id="idlRptPlatform"
                          >
                              {i18next.t("platform")}
                          </MenuItem>
                          <MenuItem
                              onClick={() => this.onChangeTrd_opt("others", "OUT")}
                              id="idlRptOthers"
                          >
                              {i18next.t("others")}
                          </MenuItem>
                          </DropdownButton>
                      </div>
                      <div
                          className={`${styles.alldealcreateddrpdown} alldealdrpdown`}
                          id="alldealCreatedDrpdown"
                      >
                          <DropdownButton
                          title={i18next.t(createdByValue)}
                          id="bg-nested-dropdown"
                          className={`${styles.filterItembtn} reportsDropdown btnText`}
                          >
                          <MenuItem
                              eventKey="2"
                              onClick={() =>
                              this.onChangeTrdCreatedBy("createdByAll", "2")
                              }
                          >
                              {i18next.t("createdByAll")}
                          </MenuItem>
                          <MenuItem
                              eventKey="0"
                              onClick={() => this.onChangeTrdCreatedBy("me", "0")}
                          >
                              {i18next.t("me")}
                          </MenuItem>
                          <MenuItem
                              eventKey="1"
                              onClick={() => this.onChangeTrdCreatedBy("others", "1")}
                          >
                              {i18next.t("others")}
                          </MenuItem>
                          </DropdownButton>
                      </div>
                  </div>
                  <div className={styles.exportOptions}>
                      <div
                          className={`${styles.exportfileBaracc} exportfileBaracc allExportFilter`}
                      >
                          <div className="commonGoBtn" id="alldealgobtn">
                          <button
                              type="button"
                              className={
                              this.state.isRefreshDisabled === true
                                  ? `${styles.disabled} ${styles.goBtn}`
                                  : `${styles.goBtn}`
                              }
                              id="idlRptRefresh"
                              onClick={() =>
                              this.getAllDealRegData(
                                  startDate,
                                  endDate,
                                  cmdtyKey,
                                  alldealTrd_optKey,
                                  createdByKey,
                                  account_code,
                                  this.state.qty_type
                              )
                              }
                          >
                              {this.props.refreshIcon}
                          </button>
                          </div>
                          <label className={this.state.loadtableflag === true ? "disableLabel" : null}>
                          {this.props.alldealtbleData.length !== 0 && (
                              <span>
                              <ExcelFile
                                  filename="AllDealReport"
                                  element={<img src="/images/xls.png" />}
                              >
                                  <ExcelSheet
                                  dataSet={multiDataSet}
                                  name="AllDealReport"
                                  />
                              </ExcelFile>
                              </span>
                          )}
                          {this.props.alldealtbleData.length === 0 && (
                              <img src="/images/xls.png" onClick={this.changeFlag} />
                          )}
                          <span>
                              <img
                              src="/images/pdf.png"
                              onClick={() => {
                                  this.generatePdf("PDF");
                              }}
                              id="idlRptGenPDF"
                              />
                          </span>
                          </label>
                      </div>
                  </div>
              </div>
          </div>
          <div className={`${styles.alldealtbl} alldealtbl reportTblBg`} id="alldealtbl">
              {this.state.loadtableflag === true ?
                  <div className={styles.rptoverlay} >
                      <i className="fa fa-spinner fa-spin spin-big"></i>
                  </div>
              :null }
              <div className={`${styles.alldealtblTile} reportsTblGrid`}>
                  <Grid rows={this.props.alldealtbleData}  columns={alldealcols}>
              <SortingState defaultSorting={[{ columnName: 'evt_ts', direction: 'desc' }]}/>
              <IntegratedSorting columnExtensions={integratedSortingColumnExtensions}/>
                      {this.state.reportsRowsCount>10?
                <PagingState defaultCurrentPage={0}  defaultPageSize={10}  /> :null}
                      {this.state.reportsRowsCount>10?
                <IntegratedPaging /> :null}
                      <SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue}/>
                      <IntegratedFiltering/>
                      <Table tableComponent={withStyles(rowStyle, { name: 'TableComponent' })(TableComponentBase)} columnAutoWidth={true} cellComponent={TableCell} columnExtensions={integratedSortingColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell}/>
                      <TableHeaderRow showSortingControls />
                      <TableColumnVisibility hiddenColumnNames={this.state.HiddenAllDealCol} onHiddenColumnNamesChange={this.onChangeHiddenAllDealCol}/>
              {this.state.reportsRowsCount>10 && this.props.selectedCssColor !== "DR" ?<PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer}/>
              :
              this.state.reportsRowsCount>10 && this.props.selectedCssColor === "DR" ?
              <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark}/>
              :null}
                      <Toolbar />
                      <SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password"/>
                      <ColumnChooser />
                  </Grid>
              </div>
          </div>
      </div>
      );
  }
}
